import {Alert} from 'react-bootstrap';

/** Props for {@link SignInAlert}. */
interface SignInAlertProps {
  /** The message, already translated. `null` or empty shows nothing. */
  message: string | null;
}

/**
 * A sign-in failure the student can act on, such as a dropped connection,
 * shown under the sign-in controls and announced by screen readers when it
 * appears. The sign-in button above it is the retry.
 *
 * @param props.message - What to say.
 * @return The alert, or nothing when there is no message.
 * @throws Never.
 */
export function SignInAlert({message}: SignInAlertProps) {
  if (!message) {
    return null;
  }
  return (
    <Alert variant="danger" className="mt-2 mb-2 py-2" role="alert">
      {message}
    </Alert>
  );
}
